import session from './session'
import shop from './shop'
import user from './user'
import members from './members'
import kit from './kit'
import rrc from './rrc'

const reducers = {
  session,
  shop,
  user,
  members,
  kit,
  rrc
}

export default reducers
